import { tracked } from '@glimmer/tracking';

import FilterSortTeam from 'webapp/models-custom/filter-sort/team';

export default class FilterSortTeamInGrid extends FilterSortTeam {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
